import { render, staticRenderFns } from "./EsgBasePagination.vue?vue&type=template&id=052304b2&scoped=true"
import script from "./EsgBasePagination.vue?vue&type=script&lang=js"
export * from "./EsgBasePagination.vue?vue&type=script&lang=js"
import style0 from "./EsgBasePagination.vue?vue&type=style&index=0&id=052304b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052304b2",
  null
  
)

export default component.exports